import store from "../store";

export const updateRuntimeStore = (data) => {
	store.dispatch({
		type: "UPDATE_RUNDOWN_STORE",
		data,
	});
};
